module.exports = __webpack_public_path__ + "img/dianchi-100.202ffc15.svg";